/** @jsxImportSource @emotion/react */
/* eslint-disable react/jsx-props-no-spreading */
import { components } from "react-select";
import Popper from "components/common/Popper";
import PropTypes from "prop-types";
import { ReactComponent as CheckMark } from "assets/icons/Check.svg";
import optionCss from "./index.css";

export default function Option(props) {
  const { isSelected, children, label } = props;

  return (
    <components.Option {...props}>
      <Popper text={label}>
        <span css={optionCss}>{children}</span>
      </Popper>
      {isSelected && <CheckMark />}
    </components.Option>
  );
}

Option.propTypes = {
  isSelected: PropTypes.bool,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};
